import { AuthCardLayout } from "./AuthCardLayout";
import { Alert } from "@mui/material";

export default function SignOutScreen() {
  return (
    <AuthCardLayout>
      <Alert color="info">You are being signed out...</Alert>
    </AuthCardLayout>
  )
}